import { format, formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

type DateInput = string | number | Date;

/** Short pt-BR date (`25/09/2026`) for tables, details, and summaries. */
export const dateFormat = (value: DateInput) => format(new Date(value), "dd/MM/yyyy");

/** Date and time (`25/09/2026 14:03`) for timestamps and tooltips. */
export const dateTimeFormat = (value: DateInput) => format(new Date(value), "dd/MM/yyyy HH:mm");

/** Long pt-BR date (`25 de setembro de 2026`) for editorial headings. */
export const longDateFormat = (value: DateInput) =>
  format(new Date(value), "d 'de' MMMM 'de' yyyy", { locale: ptBR });

/** Relative pt-BR time (`há 3 dias`) for feeds and activity lists. */
export const relativeTimeFormat = (value: DateInput) =>
  formatDistanceToNow(new Date(value), { addSuffix: true, locale: ptBR });

/** Month and year (`setembro 2026`) for group headings. */
export const monthYearFormat = (value: DateInput) =>
  format(new Date(value), "MMMM yyyy", { locale: ptBR });
